import { Grid, Group, Stack, Text } from '@mantine/core';
import { useMemo } from 'react';

import { TSDData } from '@e-origin/contracts';
import { TSDType } from '@e-origin/shared';

import { BackButton, TextInput } from '@components';
import { TSDStatusIndicator } from '../TSDStatusIndicator';
import { getStatusLabel } from '../utils';

interface TSDViewHeaderProps {
  tsd: TSDData;
}

export const TSDViewHeader: React.FC<TSDViewHeaderProps> = ({ tsd }) => {
  const status = useMemo(() => getStatusLabel(tsd.generalInfo?.status), [tsd.generalInfo?.status]);

  const typeLabels: Record<TSDType, string> = {
    [TSDType.PRELODGED]: 'Pre-lodged',
    [TSDType.COMBINED]: 'Combined',
    [TSDType.TRANSFERRED]: 'Transferred',
  };
  const type = useMemo(() => typeLabels[tsd.generalInfo?.type], [tsd.generalInfo?.type]);

  return (
    <Stack px="xl" gap="xl" mb="md" mx="xl">
      <BackButton backPath="/tsd" data-pw="tsd-view-back-button"></BackButton>
      <Group>
        <Stack mr="lg" gap="xs">
          <Text size="xs">TSD name</Text>
          <Text size="xl" fw={700} lh="xs">
            {tsd.name}
          </Text>
        </Stack>
        <Stack mr="lg" gap="xs">
          <Text size="xs">Status</Text>
          <Group gap="xs">
            <TSDStatusIndicator status={tsd.generalInfo.status} />
            <Text data-pw="tsd-status" size="xl" fw={700} c="blue" lh="xs">
              {status}
            </Text>
          </Group>
        </Stack>
        <TextInput miw="250px" label="LRN" value={tsd.messageInfo?.LRN} disabled />
        <TextInput miw="250px" label="MRN" value={tsd.messageInfo?.MRN} disabled />
        <TextInput miw="250px" label="FRN" value={tsd.messageInfo?.FRN} disabled />
        <TextInput miw="250px" label="CRN" value={tsd.messageInfo?.CRN} disabled />
      </Group>
      <Grid>
        <Grid.Col span={2}>
          <TextInput label="Type" value={type} disabled />
        </Grid.Col>
        <Grid.Col span={1.5}>
          <TextInput label="Packages" value={tsd.consignment?.master?.totalNumberOfPackages} disabled />
        </Grid.Col>
        <Grid.Col span={1.5}>
          <TextInput label="Total Gross" value={tsd.consignment?.master?.totalGrossMass} disabled />
        </Grid.Col>
        <Grid.Col span={1.5}>
          <TextInput label="Location" value={`${tsd.locationOfGoods?.typeOfLocation || ''} ${tsd.warehouse?.identifier || ''}`} disabled />
        </Grid.Col>
        <Grid.Col span={2}>
          <TextInput label="Previous Doc Type" value={tsd.consignment?.master?.previousDocuments?.[0]?.type} disabled />
        </Grid.Col>
        <Grid.Col span={1.5}>
          <TextInput label="Items" value={tsd.consignment?.master?.consignmentItems?.length} disabled />
        </Grid.Col>
      </Grid>
    </Stack>
  );
};
